(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[340],{

/***/ 13849:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/models/shop",
      function () {
        return __webpack_require__(55008);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 55008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ shop; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./common/SeoMetaData.tsx
var SeoMetaData = __webpack_require__(25384);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./common/bit/hooks/useShopUrl.tsx
var useShopUrl = __webpack_require__(11439);
// EXTERNAL MODULE: ./components/homepage/colorSwiper/ColorImageSwiper.tsx
var ColorImageSwiper = __webpack_require__(46973);
// EXTERNAL MODULE: ./components/homepage/colorSwiper/SwiperFooterText.tsx
var SwiperFooterText = __webpack_require__(65138);
// EXTERNAL MODULE: ./components/homepage/colorSwiper/SwiperTopText.tsx
var SwiperTopText = __webpack_require__(96164);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./theme/shared.tsx
var shared = __webpack_require__(6089);
;// CONCATENATED MODULE: ./components/ShopLobby/ShopLobby.tsx



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  margin: 0;\n  margin-top: 47px;\n  text-align: center;\n  font-weight: 400;\n  ",
        " {\n    font-size: 28px;\n    margin-top: 28px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  contain: paint;\n  max-width: 100vw;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  ",
        " {\n    justify-content: center;\n    height: calc(100vh - ",
        "px - 50px);\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 300;\n  text-align: center;\n  line-height: 1.4;\n  width: 300px;\n  margin-top: 32px;\n\n  ",
        " {\n    width: 500px;\n    padding: 0;\n    font-size: 18px;\n    line-height: 1.5;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 400;\n  text-align: center;\n  line-height: 1.4;\n  margin-top: 32px;\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  gap: 12px;\n\n  ",
        " {\n    padding: 0;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}








// Assuming a similar model structure as seen in Mazda project, adjust if needed
// import { ModelsPageModel } from 'path/to/model/type';
var StyledContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopLobby__StyledContainer",
    componentId: "sc-db6e353f-0"
})(_templateObject());
var StyledTitle = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    displayName: "ShopLobby__StyledTitle",
    componentId: "sc-db6e353f-1"
})(_templateObject1(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledSwiperMain = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopLobby__StyledSwiperMain",
    componentId: "sc-db6e353f-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.up("md");
}, shared/* HEADER_HEIGHT_D */.gw);
var StyledDisclaimer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopLobby__StyledDisclaimer",
    componentId: "sc-db6e353f-3"
})(_templateObject3(), function(p) {
    return p.theme.breakpoints.up("md");
});
var StyledOutOfStockText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "ShopLobby__StyledOutOfStockText",
    componentId: "sc-db6e353f-4"
})(_templateObject4(), function(p) {
    return p.theme.colors.mazdaRed;
}, function(p) {
    return p.theme.breakpoints.up("md");
});
var mapCarModelStrip = function(car) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, car), {
        modelColors: [
            {
                order: 0 /* int32 */ ,
                colorHex: "#FFFFFF" /* string */ ,
                colorCode: "white" /* string */ ,
                colorImage: car.image,
                image: car.image
            }, 
        ]
    });
};
var ShopLobby = function(param) {
    var carsStrip = param.carsStrip;
    var ref, ref1;
    var ref2 = (0,react.useState)(0), activeIndex = ref2[0], setActiveIndex = ref2[1];
    var ref3 // Default color index
     = (0,react.useState)(0), colorIndex = ref3[0];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var ref4 // Corrected destructuring
     = (0,react.useState)(null), firstSwiper = ref4[0], setFirstSwiper = ref4[1];
    var ref5 // Assuming secondSwiper might need a setter too, adjust if needed
     = (0,react.useState)(null), secondSwiper = ref5[0];
    var link = (0,useShopUrl/* default */.Z)((ref = carsStrip[activeIndex]) === null || ref === void 0 ? void 0 : ref.id);
    var carLink = ((ref1 = carsStrip[activeIndex]) === null || ref1 === void 0 ? void 0 : ref1.isInShop) ? link : "";
    var mappedCarsStrip = carsStrip.map(mapCarModelStrip);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTitle, {
                children: "כאן מתחילה הדרך לרכב החדש שלך"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSwiperMain, {
                children: [
                    carsStrip[activeIndex].isInShop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDisclaimer, {
                        children: [
                            "להבטחת ההזמנה יש לשלם מקדמה בלבד.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "לאחר מכן, ניצור איתך קשר לאישור ההזמנה ונמשיך בתהליך הרכישה"
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutOfStockText, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/icons/out-of-stock-icon.svg",
                                alt: "לא במלאי",
                                width: "24",
                                height: "24"
                            }),
                            "לא במלאי באתר"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ColorImageSwiper/* default */.Z, {
                        carsStrip: mappedCarsStrip,
                        setActiveIndex: setActiveIndex,
                        colorIndex: colorIndex,
                        setControlledSwiper: setFirstSwiper,
                        controlledSwiper: secondSwiper,
                        isShop: true
                    }),
                    carsStrip[activeIndex] && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperTopText/* default */.Z, {
                        carData: mappedCarsStrip[activeIndex],
                        carLink: carLink,
                        isShop: true
                    }),
                    carsStrip[activeIndex] && /*#__PURE__*/ (0,jsx_runtime.jsx)(SwiperFooterText/* default */.Z, {
                        card: mappedCarsStrip[activeIndex],
                        activeIndex: colorIndex,
                        link: carLink,
                        colorIndex: colorIndex,
                        isShop: true
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var ShopLobby_ShopLobby = (ShopLobby);

;// CONCATENATED MODULE: ./src/pages/models/shop/index.tsx

function shop_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  padding-top: ",
        "px;\n  flex-direction: column;\n  background-color: ",
        ";\n  ",
        " {\n    padding-top: ",
        "px;\n  }\n"
    ]);
    shop_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var StyledPageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "shop__StyledPageWrapper",
    componentId: "sc-c7a2d0be-0"
})(shop_templateObject(), shared/* HEADER_HEIGHT_M */.Gi, function(p) {
    return p.theme.colors.lightGrey;
}, function(p) {
    return p.theme.breakpoints.up("md");
}, shared/* HEADER_HEIGHT_D */.gw);
var Models = function(param) {
    var seo = param.seo, modelsData = param.modelsData;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoMetaData/* default */.ZP, {
                data: seo
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPageWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShopLobby_ShopLobby, {
                    carsStrip: modelsData
                })
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var shop = (Models);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4856,6043,6205,9774,2888,179], function() { return __webpack_exec__(13849); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);